import axios, { AxiosResponse } from 'axios';
import * as utils from '../apiUtils';
import {
  Notification,
  NotificationFile,
} from '@/models/apis/notification/notificationResponse';
import {
  NotificationIndexParams,
  NotificationCreateRequest,
  NotificationUpdateRequest,
} from '@/models/apis/notification/notificationRequest';

export default {
  index(params?: NotificationIndexParams): Promise<AxiosResponse<Notification[]>> {
    return axios.get(utils.getApiUrl('/admin/notifications'), {
      params: params || {},
    });
  },
  create(params: NotificationCreateRequest): Promise<AxiosResponse<Notification>> {
    const formData = utils.transformFormData(params);
    return axios.post(utils.getApiUrl('/admin/notifications'), formData);
  },
  update(id: number, params: NotificationUpdateRequest): Promise<AxiosResponse<Notification>> {
    const formData = utils.transformFormData(params);
    return axios.post(utils.getApiUrl(`/admin/notifications/${id}`), formData, {
      headers: {
        'X-HTTP-Method-Override': 'PUT',
      },
    });
  },
  destroy(id: number): Promise<AxiosResponse<Notification>> {
    return axios.delete(utils.getApiUrl(`/admin/notifications/${id}`));
  },
  getFiles(id: number): Promise<AxiosResponse<NotificationFile[]>> {
    return axios.get(utils.getApiUrl(`/admin/notifications/${id}/files`));
  },
};
